export default __webpack_public_path__ + "static/media/Grey Water Disposal - Coral.5c6aa4be.svg";